import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Inset } from 'syf-component-library/ui/spacing';
import { Icon, IconText } from './subcomponents';
var IconWithText = function (_a) {
    var iconName = _a.iconName, iconSize = _a.iconSize, iconColor = _a.iconColor, children = _a.children;
    return (_jsxs(IconText, { children: [_jsx("span", { children: _jsx(Icon, { name: iconName, size: iconSize, color: iconColor }) }), _jsx(Inset, { vertical: "xsmall" }), _jsx("span", { children: children })] }));
};
export default IconWithText;
//# sourceMappingURL=index.js.map